import { render, staticRenderFns } from "./hanbger-form.vue?vue&type=template&id=6137346a&scoped=true&"
import script from "./hanbger-form.vue?vue&type=script&lang=js&"
export * from "./hanbger-form.vue?vue&type=script&lang=js&"
import style0 from "./hanbger-form.vue?vue&type=style&index=0&id=6137346a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6137346a",
  null
  
)

export default component.exports